import axios from 'axios';

const ENVELOPE_TIMEOUT = 20 * 1000;
const VIEW_TIMEOUT = 60 * 1000; // can be a long wait for larger PDFs

const DocusignService = {
  VIEW_POLL_INTERVAL: 5 * 1000,
  ENVELOPE_STATUSES: { // technically this is our external provider statuses
    SENT: 'sent',
    SIGNED: 'signed',
    COMPLETED: 'completed',
    VOID: 'void',
    AUTH_FAILED: 'auth_failed', // recipient exhausted their KBA / SMS Auth attempts
  },
  SIGNER_EVENTS: {
    ID_CHECK_FAILED: 'id_check_failed',
  },
  SIGNER_EVENT_MESSAGE_TYPE: 'DOCUSIGN_EVENT',
  cancelCurrentCall() {
    if (this.controller) {
      this.controller.abort();
    }
  },
  async createDocusignEnvelope(shuttleRootPath, electionId, abortController, params = {}, timeout = ENVELOPE_TIMEOUT) {
    return axios.request({
      method: 'post',
      url: `${process.env.REACT_APP_API_ENDPOINT}/${shuttleRootPath}/election/${electionId}/docusign/envelopes`,
      params, // { formType, insurer }, // TODO TEMP BEHAVIOR, to be removed in election backend branch
      timeout,
      signal: abortController.signal,
    });
  },
  async getDocusignEnvelopeStatus(shuttleRootPath, electionId, envelopeId, planId) {
    return (await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/${shuttleRootPath}/election/${electionId}/docusign/envelopes/${envelopeId}/status`, {
      params : { planId },
    })).data;
  },
  async getDocusignRecipientUrl(shuttleRootPath, electionId, params, abortController, timeout = VIEW_TIMEOUT) {
    const url = `${process.env.REACT_APP_API_ENDPOINT}/${shuttleRootPath}/election/${electionId}/docusign/views`;

    return axios.request({
      url,
      params, // : { formType, insurer }, // TODO TEMP BEHAVIOR, to be removed in election backend branch
      signal: abortController.signal,
      timeout,
    });
  },
};

export default DocusignService;

// Copyright © 2023 Micruity Inc.
